/**
 * Converte um array de objetos em uma string CSV.
 *
 * @param array o array de objetos a converter
 * @param separator o separador a usar entre valores
 * @returns uma string representando o array como CSV
 */
const convertToCSV = (array, separator) => {
  let str = "";

  if (array.length === 0) return str;

  const arrayKeys = Object.keys(array[0] ?? {});

  for (const el of array ?? []) {
    let line = "";
    for (const key of arrayKeys) {
      if (line !== "") line += separator;
      line += str === "" ? key.toString() : el[key] ? `"${el[key]?.toString()}"` : "";
    }
    str += line + "\r\n";
  }
  return str;
};

/**
 * Faz o download dos dados como um arquivo CSV.
 *
 * @param data Os dados a serem exportados, que devem ser um array de objetos.
 * @param fileName O nome do arquivo a ser exportado.
 * @param separator O separador a ser usado no arquivo CSV. Padrão  ','  (vírgula).
 */
const downloadCSV = (data, fileName, separator = ";") => {
  const csvData = new Blob([convertToCSV(data, separator)], { type: "text/csv" });
  const csvURL = URL.createObjectURL(csvData);
  const link = document.createElement("a");
  link.href = csvURL;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { downloadCSV };
